import Api from "@/services/api";
import {
    Player,
    PlayerActionDto,
    PlayerActivationDto,
    PlayerCreateDto,
    PlayerDto,
    PlayerLogFilterDto,
    PlayerMultipleActionDto
} from "@/services/players/types";

export async function getPlayers(): Promise<Array<Player >> {
    return new Promise((resolve, reject) => {
        Api.get("/player").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getPlayer(id: string): Promise<Player> {
    return new Promise((resolve, reject) => {
        Api.get(`/player/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updatePlayer(player: PlayerDto): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.put(`/player`, player).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function createPlayer(player: PlayerCreateDto): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/player`, player).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function setAction(request: PlayerActionDto): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/player/action`, request).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function retrieveScreenshot(playerId: number): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.get(`/player/screenshot/${playerId}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getLogs(request: PlayerLogFilterDto): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/player/logs`, request).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function activatePlayer(playerId: string): Promise<PlayerActivationDto> {
    return new Promise((resolve, reject) => {
        Api.post(`/player/activate/${playerId}`, null).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function deletePlayer(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.delete(`/player/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function setMultipleAction(request: PlayerMultipleActionDto): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/player/action/multiple`, request).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getPlayersWithScreenshot(): Promise<Player[]> {
    return new Promise((resolve, reject) => {
        Api.get(`/player/screenshot`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getPreviewRenderUrl(
    playerId: string
): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.get(`/player/previewRenderUrl/${playerId}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
